import { GiPointyHat } from 'react-icons/gi';
import { getIcon } from '../../utils/iconMap';
import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiX } from 'react-icons/fi';


const GnomeToast = ({ gnome, title, message, onClick, onDismiss }) => {
    // Resolve icon using the same logic as GnomesDropdown/GnomeChat
    let IconComponent = GiPointyHat;
    if (gnome.icon) {
        // If it's already a component (unlikely from DB but possible from objects), use it
        if (typeof gnome.icon !== 'string') {
             IconComponent = gnome.icon;
        } else {
             IconComponent = getIcon(gnome.icon) || getIcon(gnome.icon) || getIcon(gnome.icon) || getIcon(gnome.icon) || IconComponent;
        }
    }

    return (
        <div
            onClick={onClick}
            className="flex items-start gap-3 w-full bg-white dark:bg-charcoal-900 border border-charcoal-200 dark:border-charcoal-800 rounded-lg p-4 shadow-lg cursor-pointer hover:bg-charcoal-50 dark:hover:bg-charcoal-800 transition-colors pointer-events-auto"
        >
            {/* Gnome Avatar */}
            <div className="relative flex-shrink-0 w-10 h-10">
                <div className={`w-full h-full rounded-full flex items-center justify-center text-white shadow-sm ${gnome.headshot ? '' : (gnome.id == 0 ? 'bg-slate-900' : (gnome.displayColor || gnome.color || 'bg-charcoal-500'))} overflow-hidden ${gnome.id == 0 ? 'bg-slate-900' : ''}`}>
                    {gnome.headshot ? (
                        <img src={gnome.headshot} alt={gnome.displayName || gnome.title} className="w-full h-full object-cover" />
                    ) : (
                        <SafeIcon icon={IconComponent} className="text-xl" />
                    )}
                </div>

                {/* Optional Status Dot */}
                <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 bg-green-500 border-2 border-white dark:border-charcoal-900 rounded-full z-10"></span>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                    <h4 className="text-sm font-bold text-charcoal-900 dark:text-white truncate">
                        {(gnome.displayName || gnome.title) === 'The Agency' ? 'Team Chat' : (gnome.displayName || gnome.title)}
                    </h4>
                    <span className="text-[10px] text-charcoal-400">Just now</span>
                </div>
                {/* <p className="text-xs font-medium text-charcoal-700 dark:text-charcoal-300 mt-0.5 truncate">{title}</p> */}
                <p className="text-xs text-charcoal-600 dark:text-charcoal-400 mt-1 line-clamp-2 leading-relaxed">
                    {message}
                </p>
            </div>

            {/* Close Button (Optional, handled by sonner usually but good for explicit dismissal) */}
            {/* <button
                onClick={(e) => { e.stopPropagation(); onDismiss(); }}
                className="text-charcoal-400 hover:text-charcoal-600 dark:hover:text-charcoal-200"
            >
                <FiX size={14} />
            </button> */}
        </div>
    );
};

export default GnomeToast;
